// Dependency
import React from "react";

// Styles
import * as errorStyles from './error.module.scss';

// Components
import NotificationBreak from "./notification-break";
import NotificationSuccess from "./notification-success";
import NotificationWarning from "./notification-warning";
import NotificationInfo from "./notification-info";

// Template
const Error = ({ type, data,  toggleNotification }) => {

    return (
        <div className={errorStyles.cdErrorWrapper}>

            <NotificationBreak isOpen={type === 'break'} toggleNotification={toggleNotification}>
                { data && <h4>No Flow</h4> }
                { data && <p>{data.text}</p> }
            </NotificationBreak>

            <NotificationSuccess isOpen={type === 'success'} toggleNotification={toggleNotification}>
                { data && <h4>Great Flow</h4> }
                { data && <p>{data.text}</p> }
            </NotificationSuccess>

            <NotificationWarning isOpen={type === 'warning'} toggleNotification={toggleNotification}>
                { data && <h4>Disturbance in the Flow</h4> }
                { data && <p>{data.text}</p> }
            </NotificationWarning>

            <NotificationInfo isOpen={type === 'info'} toggleNotification={toggleNotification}>
                { data && <h4>Info</h4> }
                { data && <p>{data.text}</p> }
            </NotificationInfo>

        </div>
    )
}

export default Error
